var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.0941L15.0084 8.08578L13.8309 6.90662L10 10.7399L6.17003 6.90662L4.9917 8.08495L10 13.0941Z",
    fill: "#1F384C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.12f79cdb9ba977e35e85ac8c214916d2.svg";
export { ForwardRef as ReactComponent };